export const API_DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm';
